/**
 * Created by kiruba on 14/09/18.
 */

var defaultPaginationLimit = 5;
var excludedFileTypes = ['exe', 'msi', 'dmg'];
var stripeJsUrl = 'https://js.stripe.com/v3/';